import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { E金融借入科目, E金融借入種別, E金融借入返済方法 } from '@/openapi/enum';

import InputableText from '@/components/inputableText/InputableText.vue';
import ElDatePickerMixin from '@/mixins/ElDatePickerMixin';
import EditRowMixin from '@/entries/user/mixins/EditRowMixin';
import InputableTextBaseMixin from '@/entries/user/mixins/InputableTextBaseMixin';
import { InputableTextMixin } from '@/components/inputableText/InputableText';

import { 金融機関借入ListItem } from '@/classes/service/分析計画/金融機関借入Service';

export default mixins(ElDatePickerMixin, EditRowMixin, InputableTextMixin, InputableTextBaseMixin).extend({
  name: 'C金融機関借入EditRow',

  components: {
    InputableText,
  },

  props: {
    editItem: {
      type: Object as PropType<金融機関借入ListItem>,
      required: true,
    },
    reload: {
      type: Number,
      required: false,
    },
  },

  data(): {
    e種別: typeof E金融借入種別;
    e科目: typeof E金融借入科目;
    e返済方法: typeof E金融借入返済方法;
  } {
    return {
      e種別: E金融借入種別,
      e科目: E金融借入科目,
      e返済方法: E金融借入返済方法,
    };
  },

  methods: {
    change返済方法(): void {
      if (this.editItem.返済方法 !== E金融借入返済方法.元利均等) return;

      this.editItem.初回元本返済額 = undefined;
      this.editItem.二回目以降元本返済額 = undefined;
      this.editItem.最終回元本返済額 = undefined;
    },
    changeCell(value: string | number, row: 金融機関借入ListItem, key: string): void {
      if (row != null) this.$set(row, key, Number(value));
    },
  },
});
